export const education = [
  {
    id: 1,
    degree: 'BSc (Hons) in Software Engineering',
    institution: 'Java Institute for Advanced Technology',
    location: 'Sri Lanka',
    duration: 'Present',
    description: 'Currently pursuing a BSc (Hons) in Software Engineering at JIAT.',
    subtitle: 'Software Engineering',
    system: 'Undergraduate Program',
    statusBadges: ['UNDERGRADUATE'],
    courses: ['Data Structures', 'Algorithms', 'Database Systems', 'Web Development', 'Software Engineering', 'UI/UX Design'],
    achievements: [
      'Building real-world projects with React, Node.js, and SQL',
      'Practicing clean code, Git workflows, and basic testing',
      'Focusing on responsive UI, accessibility, and performance',
      'Improving problem-solving with Data Structures & Algorithms'
    ],
    icon: 'GraduationCap'
  },
  {
    id: 2,
    degree: 'Diploma in English',
    subtitle: 'English Diploma',
    institution: 'ESOFT Metro Campus',
    location: 'Sri Lanka',
    duration: 'Present',
    system: 'Communicative Approach to Language Teaching',
    chips: [
      { label: 'UK Accredited', variant: 'accent' },
      { label: 'Distinction Level', variant: 'accent' }
    ],
    statusBadges: ['ONGOING'],
    description: 'Developing core English skills (Listening, Speaking, Reading, Writing) through interactive sessions using the communicative approach.',
    courses: ['Listening', 'Speaking', 'Reading', 'Writing'],
    achievements: [
      'Improving spoken fluency and accuracy through practice',
      'Enhancing reading comprehension and academic writing skills',
      ' spoken confidence through interactive sessions',
      ' grammar accuracy for professional communication'
    ],
    icon: 'Target'
  },
 
  {
    id: 3,
    degree: 'G.C.E. Ordinary Level Examination',
    institution: 'Department of Examinations, Sri Lanka',
    location: 'Sri Lanka',
    duration: '2020',
    subtitle: 'Ordinary Level Examination',
    system: 'Sri Lankan Education System',
    period: '2020 - 2021',
    statusBadges: ['QUALIFIED'],
    description: 'Index No: 64956890',
    results: [
      { subject: 'Buddhism', grade: 'B' },
      { subject: 'Sinhala', grade: 'C' },
      { subject: 'English', grade: 'C' },
      { subject: 'Mathematics', grade: 'B' },
      { subject: 'History', grade: 'C' },
      { subject: 'Science', grade: 'B' },
      { subject: 'Art', grade: 'C' },
      { subject: 'Geography', grade: 'B' },
      { subject: 'ICT', grade: 'B' },
    ],
    icon: 'Target'
  },
  
  {
    id: 4,
    degree: 'Level 3 Diploma in Information Technology',
    subtitle: 'Professional Diploma',
    institution: 'Esoft Metro Campus',
    location: 'Sri Lanka',
    duration: '2024',
    system: 'UK Accredited',
    chips: [
      { label: 'UK Accredited', variant: 'info' },
      { label: 'Distinction Level', variant: 'accent' }
    ],
    statusBadges: ['CERTIFIED'],
    description: 'Successfully completed Level 3 Diploma in Information Technology with majority Distinction grades across modern IT modules.',
    modules: [
      { name: 'IT Concepts', grade: 'Distinction' },
      { name: 'MS Office', grade: 'Merit' },
      { name: 'Computer Hardware', grade: 'Distinction' },
      { name: 'Network Essentials', grade: 'Distinction' },
      { name: 'Web Design', grade: 'Distinction' },
      { name: 'Graphics & Multimedia', grade: 'Distinction' },
      { name: 'Software Engineering', grade: 'Distinction' },
      { name: 'Python Programming', grade: 'Distinction' },
      { name: 'SQL Databases', grade: 'Merit' },
      { name: 'C# Programming', grade: 'Distinction' },
      { name: 'Final Project', grade: 'Distinction' }
    ],
   
    icon: 'Target'
  }
  ,
  {
    id: 5,
    degree: 'G.C.E. Advanced Level Examination',
    institution: 'Department of Examinations, Sri Lanka',
    location: 'Sri Lanka',
    duration: '2023',
    subtitle: 'Advanced Level Examination',
    system: 'Sri Lankan Education System',
    period: '2023 - 2024',
    chips: [{ label: 'Bio Stream', variant: 'accent' }],
    statusBadges: ['COMPLETED'],
    description: 'Bio Stream',
    results: [
      { subject: 'Biology', grade: 'S' },
      { subject: 'Physics', grade: 'S' },
      { subject: 'Chemistry', grade: 'F' },
    ],
    icon: 'Target'
  }
]

export const certificates = [
  { id: 'c1', title: 'Dhampasala Certificate (Grade 10)', image: '/Certifications/10dhampasal.jpg' },
  { id: 'c2', title: 'Dhampasala Certificate (Grade 9)', image: '/Certifications/9dahampasal.jpg' },
  { id: 'c3', title: 'Art Competition Certificate', image: '/Certifications/art.jpg' },
  { id: 'c4', title: 'Badulla Certificate', image: '/Certifications/badulla.jpg' },
  { id: 'c5', title: 'Elle Sports Certificate', image: '/Certifications/elle.jpg' },
  { id: 'c6', title: 'Cadet Programme Certificate', image: '/Certifications/kadete.jpg' },
  { id: 'c7', title: 'Kusalatha Certificate', image: '/Certifications/kusalatha.jpg' },
  {
    id: 'c8',
    title: 'Level 3 Diploma in IT',
    issuer: 'ESOFT Metro Campus',
    issueDate: '2024',
    image: '/Certifications/levl3_1.jpg',
    images: [
      '/Certifications/levl3_1.jpg',
      '/Certifications/level3_2.jpg',
      '/Certifications/level3_3.jpg'
    ],
    chips: ['UK Accredited', 'Distinction Level']
  },
  { id: 'c11', title: 'Little Picasso Certificate', image: '/Certifications/littile_picaso.jpg' },
  { id: 'c12', title: 'Mediation Programme Certificate', image: '/Certifications/mediation_programe.jpg' },
  { id: 'c13', title: 'Shishathwa Certificate', image: '/Certifications/shishathwe.jpg' },
  { id: 'c14', title: 'Siyabalanduwa Certificate', image: '/Certifications/siyabalanduwa.jpg' },
  { id: 'c15', title: 'Volleyball Certificate', image: '/Certifications/volibol.jpg' },
]
